// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --montse: 'Montserrat', sans-serif;
  --text-color: #000;
  --button-text-color: #000;
  --white: #fff;
  --offwhite: #f8f8f8;
  --black: #000;
  --black-blur: #333;
  --black-faded: #233142;
  --mainly-blue: #264653;
  --mainly-green: #2a9d8f;
  --lavender: #dfdbe5;
  --mustard: #e9c46a;
  --sky: #87ceeb;
  --seafoam: #a8f0cb;
  /* Secondary palette */
  --lightgray: #e3e3e3;
  --vanilla: #f2ece4;
  --seablue: #b2c9d8;
  --bluehover: #ccdfeb;

  [data-theme='dark'] {
    --background-color: var(--black-blur);
    --button-background-color: var(--white);
    --modal-background-color: var(--black-blur);
    --button-background-hover-color: var(--offwhite);
    --button-text-hover-color: var(--black);
    --text-color: var(--white);
    --button-text-color: var(--black);
  }

  [data-theme='light'] {
    --background-color: var(--white);
    --button-background-color: var(--black-blur);
    --modal-background-color: var(--white);
    --button-background-hover-color: var(--black-faded);
    --button-text-hover-color: var(--white);
    --text-color: var(--black);
    --button-text-color: var(--white);
  }
}

*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  scrollbar-width: thin;
  scrollbar-color: var(--seafoam) var(--sky);
}

/* Chrome, Edge, and Safari */
*::-webkit-scrollbar {
  width: 12px;
}

*::-webkit-scrollbar-track {
  background: var(--seafoam);
}

*::-webkit-scrollbar-thumb {
  background-color: var(--sky);
  border-radius: 20px;
  border: 3px solid var(--seafoam);
}

body {
  background-color: var(--background-color);
  color: var(--text-color);
  font-size: 16px;
  line-height: 22px;
  font-family: var(--montse), 'Franklin Gothic Medium', 'Arial Narrow', Arial,
    sans-serif;
}

.home {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.mode-toggle {
  position: absolute;
  top: 15px;
  right: 20px;
  cursor: pointer;
}

.container p {
  max-width: 640px;
  text-rendering: optimizeLegibility;
}

#main {
  display: none;
}

#selectOption {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 4em;
  padding: 2em;
}

#select-container {
  display: none;
}

.map-icon {
  color: var(--text-color);
}

button,
.btn {
  background-color: var(--button-background-color);
  color: var(--button-text-color);
  border: none;
  transition: transform 0.3s ease-in-out;
  cursor: pointer;
}

button:hover,
.btn:hover {
  transform: scale(1.05);
  background-color: var(--button-background-hover-color);
  color: var(--button-text-hover-color);
}

button:active,
.btn:active {
  transform: scale(0.95);
  background-color: var(--button-background-color) !important;
  color: var(--button-text-color) !important;
}

.page-header,
h1,
h2,
h3,
h4,
h5,
h6,
p,
button,
input,
label,
li,
span,
select,
option,
textarea {
  color: var(--text-color);
}

.button-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

#map {
  width: 80vw;
  height: 60vh;
  background-color: #e4e6e9;
}

#panel {
  width: 100vw;
  overflow: auto;
  background: inherit;
}

.show {
  display: block !important;
}

.hidden {
  display: none !important;
}

/* Modal */
.modal-header,
.modal-body {
  padding: 2px 16px;
}

/* Modal Content */
.modal-content {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  background-color: var(--modal-background-color);
  color: var(--text-color);
}

.animatein {
  animation-name: animatetop;
  animation-duration: 0.5s;
}

.animateout {
  animation-name: animateout;
  animation-duration: 0.5s;
}

@keyframes animatetop {
  from {
    top: -300px;
    opacity: 0;
  }

  to {
    top: 0;
    opacity: 1;
  }
}

@keyframes animateout {
  from {
    top: 0;
    opacity: 1;
  }
  to {
    top: -300px;
    opacity: 0;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Info bubble  */
.H_ib_content > div > h1,
.H_ib_content > div > h2,
.H_ib_content > div > h3 {
  color: #fff;
}

.H_ib_body {
  width: 225px;
  height: auto;
  font-weight: 800;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  opacity: 0;
  animation: fadeIn 0.4s ease-out forwards;
}

.H_ib_tail::after {
  border-style: hidden;
}

.H_ib_content {
  max-width: 275px;
  font-size: 13px;
}

/* X marker on bubble */
.H_ib_close {
  position: revert;
  width: 15px;
  padding: 1em;
}

.H_ib_close svg.H_icon {
  border: 2px solid gray;
  padding: 1em;
  width: 2.25em;
  border-radius: 100%;
}

@media (max-width: 600px) {
  html {
    font-size: 9px;
  }

  .home {
    padding: 2em;
    height: 100vh;
  }

  .button-container {
    flex-direction: column;
  }

  .H_ib_body {
    width: 180px;
  }

  .H_ib_content {
    font-size: 11px;
  }

  /* X marker on bubble */
  .H_ib_close {
    position: revert;
    padding: 0.5em;
  }

  .H_ib_close svg.H_icon {
    border: 2px solid gray;
    padding: 0.5em;
  }

  .instructions {
    display: none !important;
  }
}

@media (min-width: 601px) and (max-width: 900px) {
  html {
    font-size: 14px;
  }
}

@media (min-width: 901px) {
  html {
    font-size: 18px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/style.css"],"names":[],"mappings":"AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;;EAEpB;IACE,qCAAqC;IACrC,uCAAuC;IACvC,2CAA2C;IAC3C,gDAAgD;IAChD,uCAAuC;IACvC,0BAA0B;IAC1B,iCAAiC;EACnC;;EAEA;IACE,gCAAgC;IAChC,4CAA4C;IAC5C,sCAAsC;IACtC,mDAAmD;IACnD,uCAAuC;IACvC,0BAA0B;IAC1B,iCAAiC;EACnC;AACF;;AAEA;;;EAGE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA,6BAA6B;AAC7B;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;EACzC,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB;cACY;AACd;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,gDAAgD;EAChD,+BAA+B;EAC/B,YAAY;EACZ,sCAAsC;EACtC,eAAe;AACjB;;AAEA;;EAEE,sBAAsB;EACtB,sDAAsD;EACtD,qCAAqC;AACvC;;AAEA;;EAEE,sBAAsB;EACtB,2DAA2D;EAC3D,0CAA0C;AAC5C;;AAEA;;;;;;;;;;;;;;;;EAgBE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,UAAU;AACV;;EAEE,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,4EAA4E;EAC5E,+CAA+C;EAC/C,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE;IACE,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,MAAM;IACN,UAAU;EACZ;AACF;;AAEA;EACE;IACE,MAAM;IACN,UAAU;EACZ;EACA;IACE,WAAW;IACX,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,iBAAiB;AACjB;;;EAGE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,uCAAuC;EACvC,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA,uBAAuB;EACvB;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Montserrat&display=swap');\n\n:root {\n  --montse: 'Montserrat', sans-serif;\n  --text-color: #000;\n  --button-text-color: #000;\n  --white: #fff;\n  --offwhite: #f8f8f8;\n  --black: #000;\n  --black-blur: #333;\n  --black-faded: #233142;\n  --mainly-blue: #264653;\n  --mainly-green: #2a9d8f;\n  --lavender: #dfdbe5;\n  --mustard: #e9c46a;\n  --sky: #87ceeb;\n  --seafoam: #a8f0cb;\n  /* Secondary palette */\n  --lightgray: #e3e3e3;\n  --vanilla: #f2ece4;\n  --seablue: #b2c9d8;\n  --bluehover: #ccdfeb;\n\n  [data-theme='dark'] {\n    --background-color: var(--black-blur);\n    --button-background-color: var(--white);\n    --modal-background-color: var(--black-blur);\n    --button-background-hover-color: var(--offwhite);\n    --button-text-hover-color: var(--black);\n    --text-color: var(--white);\n    --button-text-color: var(--black);\n  }\n\n  [data-theme='light'] {\n    --background-color: var(--white);\n    --button-background-color: var(--black-blur);\n    --modal-background-color: var(--white);\n    --button-background-hover-color: var(--black-faded);\n    --button-text-hover-color: var(--white);\n    --text-color: var(--black);\n    --button-text-color: var(--white);\n  }\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  scrollbar-width: thin;\n  scrollbar-color: var(--seafoam) var(--sky);\n}\n\n/* Chrome, Edge, and Safari */\n*::-webkit-scrollbar {\n  width: 12px;\n}\n\n*::-webkit-scrollbar-track {\n  background: var(--seafoam);\n}\n\n*::-webkit-scrollbar-thumb {\n  background-color: var(--sky);\n  border-radius: 20px;\n  border: 3px solid var(--seafoam);\n}\n\nbody {\n  background-color: var(--background-color);\n  color: var(--text-color);\n  font-size: 16px;\n  line-height: 22px;\n  font-family: var(--montse), 'Franklin Gothic Medium', 'Arial Narrow', Arial,\n    sans-serif;\n}\n\n.home {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n\n.mode-toggle {\n  position: absolute;\n  top: 15px;\n  right: 20px;\n  cursor: pointer;\n}\n\n.container p {\n  max-width: 640px;\n  text-rendering: optimizeLegibility;\n}\n\n#main {\n  display: none;\n}\n\n#selectOption {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin: 4em;\n  padding: 2em;\n}\n\n#select-container {\n  display: none;\n}\n\n.map-icon {\n  color: var(--text-color);\n}\n\nbutton,\n.btn {\n  background-color: var(--button-background-color);\n  color: var(--button-text-color);\n  border: none;\n  transition: transform 0.3s ease-in-out;\n  cursor: pointer;\n}\n\nbutton:hover,\n.btn:hover {\n  transform: scale(1.05);\n  background-color: var(--button-background-hover-color);\n  color: var(--button-text-hover-color);\n}\n\nbutton:active,\n.btn:active {\n  transform: scale(0.95);\n  background-color: var(--button-background-color) !important;\n  color: var(--button-text-color) !important;\n}\n\n.page-header,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nbutton,\ninput,\nlabel,\nli,\nspan,\nselect,\noption,\ntextarea {\n  color: var(--text-color);\n}\n\n.button-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n#map {\n  width: 80vw;\n  height: 60vh;\n  background-color: #e4e6e9;\n}\n\n#panel {\n  width: 100vw;\n  overflow: auto;\n  background: inherit;\n}\n\n.show {\n  display: block !important;\n}\n\n.hidden {\n  display: none !important;\n}\n\n/* Modal */\n.modal-header,\n.modal-body {\n  padding: 2px 16px;\n}\n\n/* Modal Content */\n.modal-content {\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n  background-color: var(--modal-background-color);\n  color: var(--text-color);\n}\n\n.animatein {\n  animation-name: animatetop;\n  animation-duration: 0.5s;\n}\n\n.animateout {\n  animation-name: animateout;\n  animation-duration: 0.5s;\n}\n\n@keyframes animatetop {\n  from {\n    top: -300px;\n    opacity: 0;\n  }\n\n  to {\n    top: 0;\n    opacity: 1;\n  }\n}\n\n@keyframes animateout {\n  from {\n    top: 0;\n    opacity: 1;\n  }\n  to {\n    top: -300px;\n    opacity: 0;\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* Info bubble  */\n.H_ib_content > div > h1,\n.H_ib_content > div > h2,\n.H_ib_content > div > h3 {\n  color: #fff;\n}\n\n.H_ib_body {\n  width: 225px;\n  height: auto;\n  font-weight: 800;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);\n  opacity: 0;\n  animation: fadeIn 0.4s ease-out forwards;\n}\n\n.H_ib_tail::after {\n  border-style: hidden;\n}\n\n.H_ib_content {\n  max-width: 275px;\n  font-size: 13px;\n}\n\n/* X marker on bubble */\n.H_ib_close {\n  position: revert;\n  width: 15px;\n  padding: 1em;\n}\n\n.H_ib_close svg.H_icon {\n  border: 2px solid gray;\n  padding: 1em;\n  width: 2.25em;\n  border-radius: 100%;\n}\n\n@media (max-width: 600px) {\n  html {\n    font-size: 9px;\n  }\n\n  .home {\n    padding: 2em;\n    height: 100vh;\n  }\n\n  .button-container {\n    flex-direction: column;\n  }\n\n  .H_ib_body {\n    width: 180px;\n  }\n\n  .H_ib_content {\n    font-size: 11px;\n  }\n\n  /* X marker on bubble */\n  .H_ib_close {\n    position: revert;\n    padding: 0.5em;\n  }\n\n  .H_ib_close svg.H_icon {\n    border: 2px solid gray;\n    padding: 0.5em;\n  }\n\n  .instructions {\n    display: none !important;\n  }\n}\n\n@media (min-width: 601px) and (max-width: 900px) {\n  html {\n    font-size: 14px;\n  }\n}\n\n@media (min-width: 901px) {\n  html {\n    font-size: 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
